<!--
 * @Author: LiuJunQin
 * @Date: 2021-06-02 09:40:13
 * @LastEditors: LiuJunQin
 * @LastEditTime: 2021-06-02 14:14:20
 * @Description: 
-->
<template>
  <div class="coupons" v-if="showCoupon">
    <div class="dashed"></div>
      <Row :gutter="56" class="coupon">
        <Col span="13">
          <div class="coitem">
            <p class="lab">{{$t('title.w67')}}</p>
            <Select style="width:140px" @on-change="onCouponChange">
              <Option v-for="item in couponList" :value="item.Id" :key="item.Id">
                <p class="sp">{{$t('title.w68')}}<span>（{{$t('title.w69')}}:{{item.ExpiredAt}}）</span></p>
              </Option>
              <Option value="0">
                <p class="sp">{{$t('title.w70')}}</p>
              </Option>
            </Select>
          </div>
          <div class="coitem">
            <p class="lab">{{$t('title.w71')}}</p>
            <p class="lp">{{coupon ? am2 : 0}} 元</p>
          </div>
        </Col>
      </Row>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      coupon: '',
      couponList: [],
      show: true
    }
  },
  props: ['am2'],
  created() {
    this.getCoupon()
  },
  computed: {
    showCoupon() {
      return this.couponList.length > 0 && this.show
    }
  },
  methods: {
    reload() {
      this.show = false
      this.$nextTick(() => this.show = true)
    },
    onCouponChange(v) {
      this.coupon = v === '0' ? '' : v
      this.$emit('on-change', this.coupon)
    },
    async getCoupon(isReload) {
      const res = await this.$axios.get('/Member/RZJLoan/AvailableManageFeeFreeList')
      if (!res.err) {
        this.couponList = res
        if (isReload) this.reload()
      }
    },
    off() {
      this.coupon = ''
      this.getCoupon(true)
    }
  },
}
</script>


<style lang='less' scoped>
  * {
    box-sizing: border-box;
  }
  // 管理费减免券新增
.dashed {
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #DADFEB, #DADFEB 7.5px, transparent 7.5px, transparent);
  background-size: 15px 100%;
}
.coupon {
  padding: 20px 0;
  .coitem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .lab {
      color: #7B7B7C;
      font-size: 14px;
    }
    .lp {
      font-size: 14px;
      font-weight: 500;
      color: #232325;
    }
    .sp {
      font-size: 14px;
      color: #333;
      font-weight: 500;
      span {
        color: #7B7B7C;
        font-weight: 400;
      }
    }
    /deep/ .ivu-select-item:hover {
      background: #E4EBF8;
    }
    /deep/ .ivu-select-selected-value {
      max-width: 128px;
      padding-left: 24px;
      white-space: normal;
    }
  }
  .coitem +.coitem {
    margin-top: 20px;
  }
}
</style>